import deviceInfo from "../deviceInfo/deviceInfo";
// @ts-ignore no type
import debounce from "lodash/debounce";
import {deviceStore} from "../../redux/device/deviceStore";

/**
 * function to send device info to redux state
 */
const sendDeviceInfoToReduxState = () => {
  deviceStore.setDevice({
    info: {
      ...deviceInfo.deviceInfo,
      isMobile: deviceInfo.getIsMobile(),
      canDoRealtimePitchShifting: deviceInfo.canDoRealtimePitchShifting(),
    },
    hardware: deviceInfo.deviceHardwareInfo,
    browser: deviceInfo.deviceBrowserInfo,
  });
}

/**
 * debounced set device info to redux state, so it doesn't update more than every second
 */
const debouncedSendDeviceInfoToReduxState = debounce(sendDeviceInfoToReduxState, 500);

/**
 * set initial device info to redux state so redux has it
 */
document.addEventListener("DOMContentLoaded", () => {
  sendDeviceInfoToReduxState();
  // on resize send device info to redux (via debounced)
  window.addEventListener('resize', debouncedSendDeviceInfoToReduxState);
});
